export const LeaveStateEnum = Object.freeze({
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
});

// Bilinmeyen/eksik durumları PENDING olarak ele alır
export const leaveStateKey = (state) =>
  Object.values(LeaveStateEnum).includes(state) ? state : LeaveStateEnum.PENDING;
